import { useTranslation } from 'react-i18next';

const LANGS: Array<{ code: 'en' | 'ka'; label: string }> = [
  { code: 'en', label: 'EN' },
  { code: 'ka', label: 'KA' },
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const current = i18n.language?.startsWith('ka') ? 'ka' : 'en';

  return (
    <div
      className="inline-flex items-center gap-0.5 rounded-full border border-stitch-border bg-stitch-surface p-0.5 shadow-stitch-card"
      role="group"
      aria-label="Language"
    >
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => i18n.changeLanguage(l.code)}
          aria-pressed={current === l.code}
          className={
            current === l.code
              ? 'min-h-[36px] min-w-[44px] rounded-full bg-stitch-primary px-3.5 py-2 text-xs font-semibold text-white transition'
              : 'min-h-[36px] min-w-[44px] rounded-full px-3.5 py-2 text-xs font-semibold text-stitch-fg-soft transition hover:text-stitch-fg'
          }
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
